import en from "./i18n-en-peopletree-Data"


// en, de, fr, pt
export default {
    en,
}
